import script from "./EditCategories.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCategories.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__